import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './pagination.styl'

export default class Pagination extends Component {
  static propTypes = {
    pages: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired,
    offset: PropTypes.number.isRequired,
    showOptions: PropTypes.number.isRequired,
    onChange: PropTypes.func,
    className: PropTypes.string
  }
  static defaultProps = {
    pages: 1,
    offset: 0,
    limit: 0,
    showOptions: 3
  }

  render() {
    const { pages, limit, offset, showOptions, className } = this.props

    let content = []

    let isActive = false

    let activePage = null

    if (pages === 1) {
      return null
    }

    for (let i = 0; i < pages; i++) {
      isActive = i * limit === offset

      if (isActive) {
        activePage = i
      }

      content = content.concat(
        <li
          key={i}
          className={`${styles.item} ${isActive ? styles.active : ''}`}
        >
          <button
            className={styles.pageBtn}
            onClick={() => this.props.onChange({ offset: i * limit })}
          >
            {i + 1}
          </button>
        </li>
      )
    }

    return (
      <div className={`${styles.pagination} ${className}`}>
        <ul className={styles.list}>
          {content.filter(page => {
            return (
              Number(page.key) <= activePage + showOptions &&
              Number(page.key) >= activePage - showOptions
            )
          })}
        </ul>
      </div>
    )
  }
}
